import { PickupOption } from 'typescript/types/api/pickup_options';

export const pickupOptionsFixture = (overrides = null): PickupOption => {
  const availability_date = overrides?.availability_date || '2025-01-01';

  const defaults = {
    reservation_id: '123',
    partner_store: 'Best Buy',
    location_id: '7',
    location_name: 'Manhattan',
    address_line_1: '123 Fake St.',
    address_line_2: '',
    locality: 'New York',
    state: 'NY',
    postal_code: '10001',
    distance_in_miles: 1.2345,
    timezone: 'America/New_York',
    open_now: true,
    days_until_available: 0,
    hours_on_availability_date: {
      date: availability_date,
      open: '2025-01-01T10:00-06:00',
      close: '2025-01-01T21:00-06:00',
    },
    availability_date,
    pickup_ready_in_minutes: 120,
    limited_availability: false,
    selected: false,
  };

  return { ...defaults, ...overrides };
};
